import React, { Component } from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Grid,
  Card,
  CardContent,
  Paper,
  TextField,
  InputAdornment,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider
} from '@mui/material';

import {
  ShoppingCart as ShoppingCartIcon,
  CalendarToday as CalendarIcon,
  People as PeopleIcon,
  TrendingUp as TrendingUpIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Visibility as VisibilityIcon,
  Delete as DeleteIcon,
  LockOpen as LockOpenIcon,
  Lock as LockIcon,
  Remove as RemoveIcon
} from '@mui/icons-material';

import { apiUrl } from '../../comp/ApiUrl';
import { toast } from 'react-toastify';

class Box2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Controle de Estado do Caixa
      isCaixaAberto: false,
      caixaId: null,
      valorAbertura: '', // Formato string "R$ 0,00"
      valorInformadoFechamento: '',
      faturamento: 0.0,

      // Valores Operacionais
      vendasDinheiro: 0.00,
      vendasCartao: 0.00,
      vendasPix: 0.00,
      suprimentos: 0.00,
      sangrias: 0.00,

      // Inputs de Movimentação (Suprimento/Sangria)
      valorMovimentacao: '',
      motivoMovimentacao: '',
      tipoMovimentacao: 'suprimento',

      // Modais
      openDialogFechamento: false,
      openDialogMovimentacao: false,

      // Histórico de Movimentações (Tabela principal)
      historicoFluxo: [],
      searchQuery: ''
    };
  }

  componentDidMount() {
    document.title = "Caixa";
    this.carregarDadosCaixa();
  }

  // Busca o status do caixa no backend ao carregar
  carregarDadosCaixa = () => {
    fetch(`${apiUrl}/store/cash-register`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            const valorAberturaFormatado = this.formatarMoedaBRL(data.valor_abertura * 100);

            this.setState({
              isCaixaAberto: true,
              caixaId: data.id,
              valorAbertura: valorAberturaFormatado,
              vendasDinheiro: Number(data.vendasDinheiro || 0),
              faturamento: Number(data.faturamento || 0),
              suprimentos: Number(data.suprimentos || 0),
              sangrias: Number(data.sangrias || 0),
              historicoFluxo: [
                ...(data.historicoFluxo || []),
                {
                  id: 'init',
                  hora: data.data_abertura || new Date().toLocaleTimeString(),
                  valor: data.valor_abertura,
                  motivo: 'Saldo Inicial (Abertura)',
                  tipo: 'Abertura'
                }
              ],
            });
          });
        }
      })
      .catch((error) => console.error("Erro ao buscar dados do caixa:", error));
  };

  // Funções Utilitárias de Moeda
  formatarMoedaBRL = (valor) => {
    if (!valor) return 'R$ 0,00';
    const apenasNumeros = String(valor).replace(/\D/g, '');
    if (!apenasNumeros) return 'R$ 0,00';
    const opcoes = { style: 'currency', currency: 'BRL' };
    return new Intl.NumberFormat('pt-BR', opcoes).format(parseFloat(apenasNumeros) / 100);
  };

  converterParaFloat = (valorFormatado) => {
    if (!valorFormatado) return 0;
    const apenasNumeros = String(valorFormatado).replace(/\D/g, '');
    if (!apenasNumeros) return 0;
    return parseFloat(apenasNumeros) / 100;
  };

  // Handlers de Input
  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  handleMoedaChange = (e) => {
    const { name, value } = e.target;
    const valorFormatado = this.formatarMoedaBRL(value);
    this.setState({ [name]: valorFormatado });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  // Requisições Backend de Operação de Caixa
  handleAbrirCaixa = (e) => {
    e.preventDefault();
    const { valorAbertura } = this.state;
    const valorFloat = (valorAbertura);

    if (valorFloat <= 0) {
      toast.warn("Por favor, insira um valor de abertura válido.");
      return;
    }

    fetch(`${apiUrl}/store/cash-register/open`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ valor_abertura: valorFloat })
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            this.setState({
              isCaixaAberto: true,
              caixaId: data.id,
              valorAbertura: valorFloat,
              historicoFluxo: [
                {
                  id: 'init',
                  tipo: 'Abertura',
                  valor: valorFloat,
                  motivo: 'Saldo Inicial (Abertura)',
                  hora: new Date().toLocaleTimeString()
                }
              ]
            });
            toast.success("Caixa aberto com sucesso!");
          });
        }
      })
      .catch(() => toast.error("Erro ao abrir o caixa"));
  };

  handleEfetuarMovimentacao = (e) => {
    e.preventDefault();
    const { tipoMovimentacao, valorMovimentacao, motivoMovimentacao, suprimentos, sangrias, historicoFluxo } = this.state;

    const valor = (valorMovimentacao);
    if (valor <= 0) {
      toast.warn("Por favor, insira um valor válido.");
      return;
    }

    const motivoFinal = motivoMovimentacao || (tipoMovimentacao === 'suprimento' ? 'Entrada manual' : 'Retirada manual');


    fetch(`${apiUrl}/store/cash-register/movements`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        caixaId: this.state.caixaId,
        tipo: tipoMovimentacao,
        valor: valor,
        motivo: motivoFinal
      })
    })
      .then((response) => {
        if (response.ok) return response.json();
        throw new Error('Erro ao registrar movimentação.');
      })
      .then((data) => {
        const novaMovimentacao = {
          id: data.id || (historicoFluxo.length + 1),
          tipo: tipoMovimentacao === 'suprimento' ? 'Suprimento' : 'Sangria',
          valor: valor,
          motivo: motivoFinal,
          hora: new Date().toLocaleTimeString()
        };

        this.setState({
          suprimentos: tipoMovimentacao === 'suprimento' ? suprimentos + valor : suprimentos,
          sangrias: tipoMovimentacao === 'sangria' ? sangrias + valor : sangrias,
          historicoFluxo: [novaMovimentacao, ...historicoFluxo],
          valorMovimentacao: '',
          motivoMovimentacao: '',
          openDialogMovimentacao: false
        });
        toast.success("Movimentação registrada com sucesso!");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Não foi possível salvar a movimentação.");
      });
  };

  handleConfirmarFechamento = () => {
    const { valorAbertura, vendasDinheiro, suprimentos, sangrias, valorInformadoFechamento, caixaId } = this.state;

    const fundoAbertura = this.converterParaFloat(valorAbertura);
    const saldoSistemaDinheiro = fundoAbertura + vendasDinheiro + suprimentos - sangrias;
    const informado = this.converterParaFloat(valorInformadoFechamento);
    const diferenca = informado - saldoSistemaDinheiro;

    fetch(`${apiUrl}/store/cash-register/close`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id_caixa: caixaId,
        valor_fechamento: informado,
        diferenca: diferenca
      })
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then(() => {
            this.setState({
              isCaixaAberto: false,
              caixaId: null,
              valorAbertura: '',
              valorInformadoFechamento: '',
              vendasDinheiro: 0,
              vendasCartao: 0,
              vendasPix: 0,
              suprimentos: 0,
              sangrias: 0,
              historicoFluxo: [],
              openDialogFechamento: false
            });
            toast.success("Caixa fechado com sucesso!");
          });
        }
      })
      .catch(() => toast.error("Erro ao fechar o caixa"));
  };

  render() {
    const {
      searchQuery,
      isCaixaAberto,
      valorAbertura,
      vendasDinheiro,
      suprimentos,
      sangrias,
      faturamento,
      historicoFluxo,
      openDialogMovimentacao,
      openDialogFechamento,
      tipoMovimentacao,
      valorMovimentacao,
      motivoMovimentacao,
      valorInformadoFechamento
    } = this.state;

    const fundoAbertura = this.converterParaFloat(valorAbertura);
    const saldoDinheiroAtual = fundoAbertura + vendasDinheiro + suprimentos - sangrias;

    // Filtro da tabela de movimentações por pesquisa
    const movimentacoesFiltradas = historicoFluxo.filter((item) =>
      (item.motivo && item.motivo.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.tipo && item.tipo.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    return (
      <Box sx={{ minHeight: '100vh', p: 1 }}>

        {/* Breadcrumbs */}
        <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ mb: 1, fontSize: '0.875rem' }}>
          <Link underline="hover" color="text.secondary" href="#">
            Início
          </Link>
          <Link underline="hover" color="text.secondary" href="#">
            Financeiro
          </Link>
          <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>
            Caixa
          </Typography>
        </Breadcrumbs>

        {/* Título da Página */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5, justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar sx={{ bgcolor: '#f0eafc', color: '#6b46c1', mr: 1.5, width: 36, height: 36 }}>
              <ShoppingCartIcon fontSize="small" />
            </Avatar>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
              Caixa
            </Typography>
            <Chip
              label={isCaixaAberto ? "CAIXA ABERTO" : "CAIXA FECHADO"}
              color={isCaixaAberto ? "success" : "error"}
              icon={isCaixaAberto ? <LockOpenIcon /> : <LockIcon />}
              sx={{ ml: 2, fontWeight: 'bold' }}
            />
          </Box>

          {isCaixaAberto && (
            <Button
              variant="contained"
              color="error"
              startIcon={<LockIcon />}
              onClick={() => this.setState({ openDialogFechamento: true })}
              sx={{ textTransform: 'none', fontWeight: 'bold' }}
            >
              Fechar Caixa
            </Button>
          )}
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Registre e acompanhe suas movimentações e fluxo do caixa do dia.
        </Typography>

        {!isCaixaAberto ? (
          /* ================= TELA DE ABERTURA ================= */
          <Grid container justifyContent="center" sx={{ mt: 4 }}>
            <Grid item xs={12} sm={6} md={5}>
              <Paper elevation={2} sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
                <Avatar sx={{ bgcolor: '#f0eafc', color: '#6b46c1', width: 56, height: 56, mx: 'auto', mb: 2 }}>
                  <LockOpenIcon fontSize="large" />
                </Avatar>
                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#1a202c' }}>
                  Abertura de Caixa
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                  Informe o valor inicial em dinheiro (troco) para abrir o caixa de hoje.
                </Typography>
                <form onSubmit={this.handleAbrirCaixa}>



                  <TextField
                    label="Valor"
                    type="text"
                    fullWidth
                    name="valorMovimentacao"
                    sx={{ mb: 3 }}
                    required
                    value={this.state.valorRSab || ''}
                    onChange={(e) => {
                      // 1. Extrai estritamente os dígitos do input
                      const apenasNumeros = e.target.value.replace(/\D/g, '');

                      if (!apenasNumeros) {
                        this.setState({
                          valorRSab: '',
                          valorAbertura: 0,
                        });
                        return;
                      }

                      // 2. Converte para número decimal real (ex: "6990" -> 69.9)
                      const valorNumber = parseFloat(apenasNumeros) / 100;

                      // 3. Formata explicitamente em BRL
                      const valorBRL = new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(valorNumber);

                      // 4. Salva o Number limpo e a String BRL no estado
                      this.setState({
                        valorRSab: valorBRL, // Exibe "R$ 69,90"
                        valorAbertura: valorNumber,       // Salva 69.9 (que enviado no JSON é 69.9)
                      });
                    }}
                  />



                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    size="large"
                    sx={{
                      backgroundColor: '#6b46c1',
                      '&:hover': { backgroundColor: '#553c9a' },
                      textTransform: 'none',
                      fontWeight: 'bold',
                      py: 1.5,
                      borderRadius: 1.5
                    }}
                  >
                    Abrir Caixa Agora
                  </Button>
                </form>
              </Paper>
            </Grid>
          </Grid>
        ) : (
          /* ================= INTERFACE DO CAIXA ABERTO ================= */
          <>
            {/* Cards de Métricas */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              {/* Card 1: Saldo Dinheiro */}
              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <Avatar sx={{ bgcolor: '#e6fffa', color: '#319795', width: 32, height: 32, mb: 1 }}>
                      <ShoppingCartIcon fontSize="small" />
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                      {saldoDinheiroAtual.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 0.5 }}>
                      Saldo em Dinheiro
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {/* Card 2: Faturamento */}
              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <Avatar sx={{ bgcolor: '#f0eafc', color: '#6b46c1', width: 32, height: 32, mb: 1 }}>
                      <CalendarIcon fontSize="small" />
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                      {faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 0.5 }}>
                      Faturamento Do Dia
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {/* Card 3: Total Sangrias */}
              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <Avatar sx={{ bgcolor: '#fff5f5', color: '#e53e3e', width: 32, height: 32, mb: 1 }}>
                      <PeopleIcon fontSize="small" />
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                      {sangrias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 0.5 }}>
                      Total de Sangrias
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {/* Card 4: Total Suprimentos */}
              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <Avatar sx={{ bgcolor: '#feebc8', color: '#dd6b20', width: 32, height: 32, mb: 1 }}>
                      <TrendingUpIcon fontSize="small" />
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                      {suprimentos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 'bold', letterSpacing: 0.5 }}>
                      Total de Suprimentos
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Barra de Pesquisa e Botões de Operação */}
            <Paper sx={{ p: 2, mb: 3, borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Pesquisar por motivo, descrição ou tipo..."
                  value={searchQuery}
                  onChange={this.handleSearchChange}
                  sx={{ flex: 1, minWidth: '200px' }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                    sx: { backgroundColor: '#f7fafc', borderRadius: 1 }
                  }}
                />

                {/* Botão de Entrada (Suprimento) */}
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => this.setState({ openDialogMovimentacao: true, tipoMovimentacao: 'suprimento' })}
                  sx={{
                    backgroundColor: '#38a169',
                    '&:hover': { backgroundColor: '#2f855a' },
                    textTransform: 'none',
                    fontWeight: 'bold',
                    px: 2.5,
                    py: 1,
                    whiteSpace: 'nowrap',
                    borderRadius: 1.5
                  }}
                >
                  Suprimento
                </Button>

                {/* Botão de Retirada (Sangria) */}
                <Button
                  variant="contained"
                  startIcon={<RemoveIcon />}
                  onClick={() => this.setState({ openDialogMovimentacao: true, tipoMovimentacao: 'sangria' })}
                  sx={{
                    backgroundColor: '#e53e3e',
                    '&:hover': { backgroundColor: '#c53030' },
                    textTransform: 'none',
                    fontWeight: 'bold',
                    px: 2.5,
                    py: 1,
                    whiteSpace: 'nowrap',
                    borderRadius: 1.5
                  }}
                >
                  Sangria
                </Button>
              </Box>
            </Paper>

            {/* Tabela de Movimentações */}
            <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.05)' }}>
              <Table>
                <TableHead sx={{ backgroundColor: '#f7fafc' }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>HORA / DATA</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>TIPO</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>MOTIVO / DESCRIÇÃO</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>VALOR</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold', color: '#4a5568', fontSize: '0.75rem' }}>AÇÕES</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {movimentacoesFiltradas.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                        Nenhuma movimentação registrada.
                      </TableCell>
                    </TableRow>
                  ) : (
                    movimentacoesFiltradas.map((row) => (
                      <TableRow key={row.id} hover>
                        <TableCell sx={{ color: '#4a5568', fontSize: '0.875rem' }}>{row.hora || '—'}</TableCell>
                        <TableCell>
                          <Chip
                            label={row.tipo}
                            size="small"
                            sx={{
                              backgroundColor: row.tipo === 'Sangria' ? '#fff5f5' : '#f0fff4',
                              color: row.tipo === 'Sangria' ? '#e53e3e' : '#38a169',
                              fontWeight: 'bold',
                              borderRadius: '12px',
                              fontSize: '0.75rem'
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ color: '#1a202c', fontWeight: 'medium', fontSize: '0.875rem' }}>{row.motivo}</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: '#1a202c', fontSize: '0.875rem' }}>
                          {Number(row.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton size="small" sx={{ color: '#718096', mr: 1 }}>
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                          <IconButton size="small" sx={{ color: '#718096' }}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}

        {/* ================= MODAL: SANGRIA / SUPRIMENTO ================= */}
        <Dialog open={openDialogMovimentacao} onClose={() => this.setState({ openDialogMovimentacao: false, valorMovimentacao: '', motivoMovimentacao: '' })}>
          <DialogTitle sx={{ fontWeight: 'bold' }}>
            {tipoMovimentacao === 'suprimento' ? 'Inserir Suprimento (Entrada)' : 'Efetuar Sangria (Retirada)'}
          </DialogTitle>
          <form onSubmit={this.handleEfetuarMovimentacao}>
            <DialogContent>
              <DialogContentText sx={{ mb: 2 }}>
                {tipoMovimentacao === 'suprimento'
                  ? 'Adicione dinheiro ao caixa para troco ou aportes de emergência.'
                  : 'Retire valores do caixa para recolhimento de segurança ou despesas.'}
              </DialogContentText>
              <TextField
                label="Motivo / Descrição"
                type="text"
                autoFocus
                fullWidth
                sx={{ mb: 2 }}
                name="motivoMovimentacao"
                value={motivoMovimentacao}
                onChange={this.handleInputChange}
                required
              />
              <TextField
                label="Valor"
                type="text"
                fullWidth
                name="valorMovimentacao"
                required
                value={this.state.valorMovimentacaoExibicao || ''}
                onChange={(e) => {
                  // 1. Extrai estritamente os dígitos do input
                  const apenasNumeros = e.target.value.replace(/\D/g, '');

                  if (!apenasNumeros) {
                    this.setState({
                      valorMovimentacaoExibicao: '',
                      valorMovimentacao: 0,
                    });
                    return;
                  }

                  // 2. Converte para número decimal real (ex: "6990" -> 69.9)
                  const valorNumber = parseFloat(apenasNumeros) / 100;

                  // 3. Formata explicitamente em BRL
                  const valorBRL = new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(valorNumber);

                  // 4. Salva o Number limpo e a String BRL no estado
                  this.setState({
                    valorMovimentacaoExibicao: valorBRL, // Exibe "R$ 69,90"
                    valorMovimentacao: valorNumber,       // Salva 69.9 (que enviado no JSON é 69.9)
                  });
                }}
              />
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
              <Button onClick={() => this.setState({ openDialogMovimentacao: false, valorMovimentacao: '', motivoMovimentacao: '' })} color="inherit">
                Cancelar
              </Button>
              <Button type="submit" variant="contained" color={tipoMovimentacao === 'suprimento' ? 'success' : 'error'}>
                Confirmar
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        {/* ================= MODAL: FECHAMENTO DE CAIXA ================= */}
        <Dialog open={openDialogFechamento} onClose={() => this.setState({ openDialogFechamento: false, valorInformadoFechamento: '' })} fullWidth maxWidth="xs">
          <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
            <LockIcon color="error" /> Fechamento de Caixa
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 3 }}>
              Para encerrar o expediente, faça a contagem do dinheiro na gaveta e informe o valor total abaixo.
            </DialogContentText>
            <TextField
              autoFocus
              label="Total em Dinheiro Contado"
              type="text"
              fullWidth
              name="valorInformadoFechamento"
              value={valorInformadoFechamento}
              onChange={this.handleMoedaChange}
              required
            />
          </DialogContent>
          <DialogActions sx={{ p: 2, pt: 0 }}>
            <Button onClick={() => this.setState({ openDialogFechamento: false, valorInformadoFechamento: '' })} color="inherit">
              Voltar
            </Button>
            <Button onClick={this.handleConfirmarFechamento} variant="contained" color="error">
              Encerrar Caixa
            </Button>
          </DialogActions>
        </Dialog>

      </Box>
    );
  }
}

export default Box2;